// extracted by mini-css-extract-plugin
export default {"tableHead":"muitable_tableHead__gwzR-","tableHeadCell":"muitable_tableHeadCell__i7Rvi","tablebody":"muitable_tablebody__KzRG2"};